import Axios from 'axios'
import Moment from 'moment'

const microbiology = {
  axios() {
    let AxiosInstance = Axios
    AxiosInstance.defaults.baseURL = process.env.REPORT_RESULTS_BASE_URL
    return AxiosInstance
  },

  searchMicrobiologyResults(filters) {
    const params = {}

    if (filters.orderId) params.orderId = filters.orderId
    if (filters.orderLisId) params.orderLisId = filters.orderLisId
    if (filters.patientName) params.patientName = filters.patientName
    if (filters.mnemonic) params.examCode = filters.mnemonic

    if (filters.startDate)
      params.registrationDateStart = Moment(filters.startDate, 'DD/MM/YYYY').format(
        'YYYY-MM-DD'
      )
    if (filters.endDate)
      params.registrationDateEnd = Moment(filters.endDate, 'DD/MM/YYYY').format(
        'YYYY-MM-DD'
      )

    params.onlyPositive = filters.onlyPositive || false
    params.page = filters.page || 0
    params.size = filters.size || 20
    params.sort = filters.sort || 'desc'
    params.sortBy = filters.sortBy || 'registrationDate'

    if (filters.status && filters.status !== 'ALL') params.status = filters.status

    return this.axios().get('/solicitations', { params })
  },

  markResultAsViewed(ids) {
    const idsParam = Array.isArray(ids) ? ids.join(',') : ids
    return this.axios().post(`/solicitations/viewed?ids=${idsParam}`)
  },
}

export default microbiology
